import { AuthService } from '../services/AuthService';
import { AuthAPI } from '../api/auth';
import { apiGet } from '../lib/http';
import { ApiResponse } from '../types/ApiResponse';
import { UserRead } from '../types/User';
import { SessionStore } from './SessionStore';
import { authManager } from '../services/AuthManager';

export class AuthStore {
  private _listeners: (() => void)[] = [];

  private static _instance: AuthStore;

  static get instance() {
    if (!AuthStore._instance) {
      AuthStore._instance = new AuthStore();
    }
    return AuthStore._instance;
  }

  async isAuthenticated(): Promise<boolean> {
    const token = authManager.getAccessToken();
    if (!token) return false;

    try {
      const res: ApiResponse<UserRead> = await apiGet<ApiResponse<UserRead>>(AuthAPI.currentUser());
      return res.statusCode === 200;
    } catch (err) {
      console.warn('Fehler beim Auth-Check', err);
      return false;
    }
  }

  onChange(callback: () => void) {
    this._listeners.push(callback);
  }

  triggerChange() {
    for (const cb of this._listeners) {
      cb();
    }
  }

  login(token: string, refreshToken: string) {
    authManager.setTokens(token, refreshToken);
    this.triggerChange();
  }

  logout() {
    AuthService.logout()
      .catch((err) => console.warn('Logout-Fehler ignoriert', err))
      .finally(() => {
        SessionStore.instance.clear();
        this.triggerChange();
      });
  }
}
